module.exports = __webpack_public_path__ + "img/48270F_C4723B_9B5728_7B431B-256px.9b40b499.png";